<template>
  <a-drawer width="85%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
     <a-form-model-item :label="$t('views.spec.form.isRequired')" prop="isRequired" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.isRequired" :placeholder="$t('views.spec.form.isRequiredPlaceholder')">
          <a-select-option v-for="item in yesNoRequiredOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.type')" prop="type" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.type" :placeholder="$t('views.spec.form.typePlaceholder')" >
          <a-select-option v-for="item in typeOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.name')" prop="name" >
        <a-input v-model="form.name" :disabled="(formType == 2 && (form.id == '648198583975288832' || form.id == '647455418200788993' || form.id == '647448821500116992'))" :placeholder="$t('views.spec.form.namePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.nameEn')" prop="nameEn" >
        <a-input v-model="form.nameEn" :disabled="(formType == 2 && (form.id == '648198583975288832' || form.id == '647455418200788993' || form.id == '647448821500116992'))" :placeholder="$t('views.spec.form.nameEnPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.isCalculation')" prop="isCalculation" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.isCalculation" :placeholder="$t('views.spec.form.isCalculationPlaceholder')" >
          <a-select-option v-for="item in yesNoCalcOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.isConflict')" prop="isConflict" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.isConflict" :placeholder="$t('views.spec.form.isConflictPlaceholder')" allow-clear>
          <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>




       <a-form-model-item :label="$t('views.spec.form.isCustomization')" prop="isCustomization" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.isCustomization" :placeholder="$t('views.spec.form.isCustomizationPlaceholder')">
          <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.identityRestrictions')" prop="identityRestrictions" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.identityRestrictions" :placeholder="$t('views.spec.form.identityRestrictionsPlaceholder')">
          <a-select-option v-for="item in identityOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
       <a-form-model-item :label="$t('views.spec.form.isDensity')" prop="isDensity" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.isDensity" :placeholder="$t('views.spec.form.isDensityPlaceholder')">
          <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.isThickness')" prop="isThickness" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.isThickness" :placeholder="$t('views.spec.form.isThicknessPlaceholder')" allow-clear>
          <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.isShow')" prop="isShow" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.isShow" :placeholder="$t('views.spec.form.isShowPlaceholder')">
          <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-divider orientation="left">{{ $t('views.spec.form.dividerOptions') }}</a-divider>
      <div style="margin-bottom: 12px;" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-button type="dashed" icon="plus" @click="addOptionRow">{{ $t('views.spec.form.addOption') }}</a-button>
      </div>
      <div v-if="!form.specOptionList || form.specOptionList.length === 0" style="color: rgba(0,0,0,0.45); margin-bottom: 12px;">
        {{ $t('views.spec.form.emptyOptions') }}
      </div>
      <a-card
        v-for="(item, idx) in form.specOptionList"
        :key="item._rowKey"
        size="small"
        :title="$t('views.spec.form.optionTitle', { n: idx + 1 })"
        style="margin-bottom: 12px;"
      >
        <template slot="extra">
          <a-button type="link" @click="removeOptionRow(idx)" style="padding: 0;" v-if="!(formType == 2 && form.id == '648198583975288832')">{{ $t('views.spec.form.removeOption') }}</a-button>
        </template>
        <a-row :gutter="12">
          <a-col :span="12">
            <a-form-model-item :label="$t('views.spec.form.optionName')" :prop="`specOptionList.${idx}.name`" :rules="[{ required: true, message: $t('views.spec.rule.optionNameRequired'), trigger: 'blur' }]">
              <a-input v-model="item.name" :disabled="(formType == 2 && form.id == '648198583975288832')" :placeholder="$t('views.spec.form.optionNamePlaceholder')" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('views.spec.form.optionNameEn')" :prop="`specOptionList.${idx}.nameEn`">
              <a-input v-model="item.nameEn" :disabled="(formType == 2 && form.id == '648198583975288832')" :placeholder="$t('views.spec.form.optionNameEnPlaceholder')" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="12">
          <a-col :span="5" v-if="!(formType == 2 && form.id == '648198583975288832')">
            <a-form-model-item :label="$t('views.spec.form.optionSort')" :prop="`specOptionList.${idx}.sort`">
              <a-input-number v-model="item.sort" style="width: 100%;" :min="0" :step="1" />
            </a-form-model-item>
          </a-col>
          <a-col :span="5" v-if="!(formType == 2 && form.id == '648198583975288832')">
            <a-form-model-item :label="$t('views.spec.form.optionIsConflict')" :prop="`specOptionList.${idx}.isConflict`">
              <a-select v-model="item.isConflict" :placeholder="$t('views.spec.form.selectPlaceholder')" allow-clear>
                <a-select-option v-for="yn in yesNoOptions" :key="yn.value" :value="yn.value">
                  {{ yn.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="12" v-if="!(formType == 2 && form.id == '648198583975288832')">
          <a-col :span="24">
            <a-form-model-item :label="$t('views.spec.form.optionRemark')" :prop="`specOptionList.${idx}.remark`">
              <a-input v-model="item.remark" :placeholder="$t('views.spec.form.optionRemarkPlaceholder')" type="textarea" :auto-size="{ minRows: 2, maxRows: 6 }" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="12" v-if="!(formType == 2 && form.id == '648198583975288832')">
          <a-col :span="24">
            <a-form-model-item :label="$t('views.spec.form.optionRemarkEn')" :prop="`specOptionList.${idx}.remarkEn`">
              <a-input v-model="item.remarkEn" :placeholder="$t('views.spec.form.optionRemarkEnPlaceholder')" type="textarea" :auto-size="{ minRows: 2, maxRows: 6 }" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-col v-if="Number(form.isDensity) === 1" :span="24">
          <a-row :gutter="12">
            <a-col :span="6">
              <a-form-model-item :label="$t('views.spec.form.materialDensity')" :prop="`specOptionList.${idx}.materialDensity`">
                <a-input-number v-model="item.materialDensity" style="width: 100%;" :min="0" :step="0.01" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="$t('views.spec.form.membraneWidth')" :prop="`specOptionList.${idx}.membraneWidth`">
                <a-input-number v-model="item.membraneWidth" style="width: 100%;" :min="0" :step="0.01" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="$t('views.spec.form.isThickness')" :prop="`specOptionList.${idx}.isThickness`">
                <a-select v-model="item.isThickness" :placeholder="$t('views.spec.form.selectPlaceholder')" allow-clear>
                  <a-select-option v-for="yn in yesNoOptions" :key="yn.value" :value="yn.value">
                    {{ yn.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item v-if="Number(item.isThickness) === 1" :label="$t('views.spec.form.materialThickness')" :prop="`specOptionList.${idx}.materialThickness`">
                <a-input-number v-model="item.materialThickness" style="width: 100%;" :min="0" :step="0.01" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>

        <a-col v-if="Number(form.isCalculation) === 1" :span="24">
          <a-row :gutter="12">
            <a-col :span="6" v-if="!(formType == 2 && form.id == '648198583975288832')">
              <a-form-model-item :label="$t('views.spec.form.sellingPrice')" :prop="`specOptionList.${idx}.sellingPrice`">
                <a-input-number v-model="item.sellingPrice" style="width: 100%;" :min="0" :step="0.001" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="!(formType == 2 && form.id == '648198583975288832') ? $t('views.spec.form.costPrice') : $t('views.spec.form.valueLabel')" :prop="`specOptionList.${idx}.costPrice`">
                <a-input-number v-model="item.costPrice" style="width: 100%;" :min="0" :step="0.001" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>

        <!-- 指定规格 ID 编辑时：子选项维护重量(g)、单位（与后端 zb_spec_option 一致） -->
        <a-col v-if="showSpecOptionWeightUnit" :span="24">
          <a-row :gutter="12">
            <a-col :span="8">
              <a-form-model-item :label="$t('views.spec.form.optionWeight')" :prop="`specOptionList.${idx}.weight`">
                <a-input-number v-model="item.weight" style="width: 100%;" :min="0" :step="0.01" />
              </a-form-model-item>
            </a-col>
            <a-col :span="16">
              <a-form-model-item :label="$t('views.spec.form.optionUnit')" :prop="`specOptionList.${idx}.unitOfMeasurement`">
                <a-input v-model="item.unitOfMeasurement" :placeholder="$t('views.spec.form.optionUnitPlaceholder')" allow-clear />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>

        <!-- 编辑规格 id=647456342948352000（拉链）或 653169480406573056（封口条）：子选项 laborCosts -->
        <a-col v-if="showSpecOptionLaborCosts" :span="24">
          <a-row :gutter="12">
            <a-col :span="10">
              <a-form-model-item :label="specOptionLaborCostsLabel" :prop="`specOptionList.${idx}.laborCosts`">
                <a-input-number v-model="item.laborCosts" style="width: 100%;" :min="0" :step="0.001" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="showSpecOptionLaborWeight" :span="10">
              <a-form-model-item :label="$t('views.spec.form.optionLaborWeight')" :prop="`specOptionList.${idx}.laborWeight`">
                <a-input-number v-model="item.laborWeight" style="width: 100%;" :min="0" :step="0.01" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>

        <a-col :span="24" v-if="!(formType == 2 && form.id == '648198583975288832')">
          <a-row :gutter="12">
            <a-col :span="8">
              <a-form-model-item :label="$t('views.spec.form.isPrompt')" :prop="`specOptionList.${idx}.isPrompt`">
                <a-select v-model="item.isPrompt" :placeholder="$t('views.spec.form.isPromptPlaceholder')">
                  <a-select-option v-for="opt in yesNoPromptOptions" :key="opt.value" :value="opt.value">
                    {{ opt.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>

        <a-col v-if="Number(item.isPrompt) === 1" :span="24">
          <a-form-model-item
            :label="$t('views.spec.form.imagePrompt')"
            :prop="`specOptionList.${idx}.url`"
            :rules="[{ validator: validateUploadNotEmpty, trigger: ['change', 'blur'] }]"
          >
            <file-upload v-model="item.url" type="image" @change="(v) => onSpecOptionUrlChange(idx, v)"></file-upload>
          </a-form-model-item>
        </a-col>
        <a-col v-if="Number(item.isPrompt) === 1" :span="24">
          <a-form-model-item :label="$t('views.spec.form.contentPrompt')" :prop="`specOptionList.${idx}.content`" :rules="[{ required: true, message: $t('views.spec.rule.contentRequired'), trigger: 'blur' }]">
            <a-input v-model="item.content" :placeholder="$t('views.spec.form.contentPromptPlaceholder')" type="textarea" :auto-size="{ minRows: 2, maxRows: 6 }" />
          </a-form-model-item>
        </a-col>
        <a-col v-if="Number(item.isPrompt) === 1" :span="24">
          <a-form-model-item :label="$t('views.spec.form.contentEnPrompt')" :prop="`specOptionList.${idx}.contentEn`">
            <a-input v-model="item.contentEn" :placeholder="$t('views.spec.form.contentEnPromptPlaceholder')" type="textarea" :auto-size="{ minRows: 2, maxRows: 8 }" />
          </a-form-model-item>
        </a-col>
      </a-card>
      <a-form-model-item :label="$t('views.spec.form.defaultOption')" prop="defaultOption" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select
          v-model="defaultOptionModel"
          :mode="Number(form.type) === 1 ? 'multiple' : undefined"
          :disabled="!form.specOptionList || form.specOptionList.length === 0"
          allow-clear
          :placeholder="$t('views.spec.form.defaultOptionPlaceholder')"
        >
          <a-select-option
            v-for="opt in (form.specOptionList || []).filter(o => o && o.id)"
            :key="opt.id"
            :value="String(opt.id)"
          >
            {{ opt.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.spec.form.isPrompt')" prop="isPrompt" v-if="!(formType == 2 && form.id == '648198583975288832')">
        <a-select v-model="form.isPrompt" :placeholder="$t('views.spec.form.isPromptPlaceholder')">
          <a-select-option v-for="item in yesNoPromptOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        v-if="Number(form.isPrompt) === 1"
        :label="$t('views.spec.form.imagePrompt')"
        prop="url"
        :rules="[{ validator: validateUploadNotEmpty, trigger: ['change', 'blur'] }]"
      >
        <file-upload v-model="form.url" type="image" :count="1" @change="onFormUrlChange" />
      </a-form-model-item>
      <a-form-model-item v-if="Number(form.isPrompt) === 1" :label="$t('views.spec.form.contentPrompt')" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item v-if="Number(form.isPrompt) === 1" :label="$t('views.spec.form.contentEnPrompt')" prop="contentEn">
        <a-input v-model="form.contentEn" :placeholder="$t('views.spec.form.contentEnPromptPlaceholder')" type="textarea" :auto-size="{ minRows: 4, maxRows: 16 }" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.spec.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.spec.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSpec, addSpec, updateSpec } from '@/api/user/spec'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        nameEn: null,

        isCalculation: 0,

        isConflict: 0,

        type: 0,

        isRequired: 1,

        isCustomization: 0,

        identityRestrictions: 0,

        defaultOption: null,

        isPrompt: 0,

        isDensity: 0,

        url: null,

        content: null,

        contentEn: null,

        isThickness: null,

        materialThickness: null,

        isShow: 1,

        sort: null,

        status: 1,

        createTime: null,

        remark: null,

        specOptionList: [],

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules () {
      return {
        name: [
          { required: true, message: this.$t('views.spec.rule.nameRequired'), trigger: 'blur' }
        ]
      }
    },
    yesNoOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.no') },
        { value: 1, label: this.$t('views.spec.enum.yes') }
      ]
    },
    yesNoCalcOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.calcNo') },
        { value: 1, label: this.$t('views.spec.enum.calcYes') }
      ]
    },
    yesNoRequiredOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.requiredNo') },
        { value: 1, label: this.$t('views.spec.enum.requiredYes') }
      ]
    },
    yesNoPromptOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.promptNo') },
        { value: 1, label: this.$t('views.spec.enum.promptYes') }
      ]
    },
    identityOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.identityNormal') },
        { value: 1, label: this.$t('views.spec.enum.identityPro') }
      ]
    },
    typeOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.typeSingle') },
        { value: 1, label: this.$t('views.spec.enum.typeMulti') }
      ]
    },
    /** 编辑且规格 ID 为指定集合时，子选项展示重量、单位 */
    showSpecOptionWeightUnit () {
      const ids = new Set([
        '653168147729391617',
        '653168447877980160',
        '653169211895619585',
        '653169480406573056',
        '647456342948352000',
        '668054146120830976'
      ])
      if (this.formType !== 2 || !this.form || this.form.id === null || this.form.id === undefined || this.form.id === '') {
        return false
      }
      return ids.has(String(this.form.id))
    },
    /** 编辑规格 id=647456342948352000（拉链）或 653169480406573056（封口条）：子选项展示 laborCosts */
    showSpecOptionLaborCosts () {
      if (this.formType !== 2 || !this.form || this.form.id === null || this.form.id === undefined || this.form.id === '') {
        return false
      }
      const id = String(this.form.id)
      return id === '647456342948352000' || id === '653169480406573056'
    },
    /** 仅拉链规格展示 laborWeight */
    showSpecOptionLaborWeight () {
      if (this.formType !== 2 || !this.form || this.form.id === null || this.form.id === undefined || this.form.id === '') {
        return false
      }
      return String(this.form.id) === '647456342948352000'
    },
    /** 封口条规格 laborCosts 显示为「人工费」 */
    specOptionLaborCostsLabel () {
      if (this.form && String(this.form.id) === '653169480406573056') {
        return this.$t('views.spec.form.optionLaborCostsSealStrip')
      }
      return this.$t('views.spec.form.optionLaborCosts')
    },
    defaultOptionModel: {
      get () {
        const raw = this.form && this.form.defaultOption
        if (Number(this.form.type) === 1) {
          return String(raw || '')
            .split(',')
            .map(s => s.trim())
            .filter(Boolean)
            .map(s => String(s))
        }
        if (raw === null || raw === undefined || raw === '') return undefined
        return String(raw)
      },
      set (val) {
        if (Number(this.form.type) === 1) {
          const list = Array.isArray(val) ? val : []
          this.form.defaultOption = list.length ? list.map(v => String(v)).join(',') : ''
          return
        }
        this.form.defaultOption = (val === null || val === undefined || val === '') ? '' : String(val)
      }
    }
  },
  watch: {
    '$i18n.locale' () {
      if (!this.open) return
      this.formTitle = this.formType === 2 ? this.$t('views.spec.title.edit') : this.$t('views.spec.title.add')
    },
    /** 主规格「是否参与计算」变更时，一级子选项 isCalculation 与主规格保持一致 */
    'form.isCalculation' (val) {
      if (!this.open) return
      this.syncSpecOptionListIsCalculation(val)
    },
    'form.type': function () {
      // 多选 -> 单选：取第一个；单选 -> 多选：保持原样即可（setter 会处理）
      if (Number(this.form.type) !== 1) {
        const raw = String(this.form.defaultOption || '')
        const first = raw.split(',').map(s => s.trim()).filter(Boolean)[0]
        this.form.defaultOption = first ? first : ''
      }
    },
    'form.specOptionList': {
      deep: true,
      handler () {
        const ids = new Set((this.form.specOptionList || []).map(o => o && o.id).filter(Boolean).map(v => String(v)))
        const raw = String(this.form.defaultOption || '')
        if (!raw) return
        if (Number(this.form.type) === 1) {
          const kept = raw.split(',').map(s => s.trim()).filter(Boolean).filter(id => ids.has(id))
          this.form.defaultOption = kept.length ? kept.join(',') : ''
        } else {
          this.form.defaultOption = ids.has(raw) ? raw : ''
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    /** 子表 isCalculation 与主规格 form.isCalculation 对齐 */
    syncSpecOptionListIsCalculation (val) {
      const list = this.form.specOptionList || []
      const v = val === null || val === undefined || val === '' ? 0 : Number(val)
      const n = Number.isNaN(v) ? 0 : v
      list.forEach((item, idx) => {
        if (!item) return
        this.$set(this.form.specOptionList[idx], 'isCalculation', n)
      })
    },
    normalizeDefaultOptionForSubmit (val) {
      if (val === null || val === undefined || val === '') {
        return ''
      }
      const str = String(val).trim()
      return str || ''
    },
    validateUploadNotEmpty (rule, value, callback) {
      // file-upload 可能返回 string / array / object，这里统一做非空判断
      if (Array.isArray(value)) {
        return value.length > 0 ? callback() : callback(new Error(this.$t('views.spec.rule.uploadImage')))
      }
      if (typeof value === 'object') {
        if (!value) {
          return callback(new Error(this.$t('views.spec.rule.uploadImage')))
        }
        const maybeUrl = value.url || value.path || value.src
        if (maybeUrl && String(maybeUrl).trim()) {
          return callback()
        }
        // 兜底：对象存在也视为有值（避免上传组件返回复杂结构导致误判）
        return callback()
      }
      if (value === null || value === undefined) {
        return callback(new Error(this.$t('views.spec.rule.uploadImage')))
      }
      const str = String(value).trim()
      return str ? callback() : callback(new Error(this.$t('views.spec.rule.uploadImage')))
    },
    onSpecOptionUrlChange (idx, val) {
      if (!this.form || !this.form.specOptionList || !this.form.specOptionList[idx]) return
      this.$set(this.form.specOptionList[idx], 'url', val)
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField(`specOptionList.${idx}.url`)
        }
      })
    },
    onFormUrlChange (val) {
      this.form.url = val
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField('url')
        }
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        nameEn: null,
        isCalculation: 0,
        isConflict: 0,
        type: 0,
        isRequired: 1,
        isCustomization: 0,
        identityRestrictions: 0,
        defaultOption: null,
        isPrompt: 0,
        isDensity: 0,
        url: null,
        content: null,
        contentEn: null,
        isThickness: null,
        materialThickness: null,
        isShow: 1,
        sort: null,
        status: 1,
        createTime: null,
        remark: null,
        specOptionList: [],
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('views.spec.title.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSpec({"id":id}).then(response => {
        const data = response.data || {}
        const optionList = (data.specOptionList || data.optionList || data.specOptions || [])
        const merged = {
          ...this.form,
          ...data,
          isConflict: data.isConflict === true ? 1 : (data.isConflict === false ? 0 : data.isConflict),
          specOptionList: Array.isArray(optionList) ? optionList.map(o => ({
            id: o.id,
            name: o.name,
            nameEn: o.nameEn,
            sort: o.sort,
            isCalculation: o.isCalculation === true ? 1 : (o.isCalculation === false ? 0 : o.isCalculation),
            isPrompt: o.isPrompt === true ? 1 : (o.isPrompt === false ? 0 : o.isPrompt),
            url: o.url,
            content: o.content,
            contentEn: o.contentEn,
            remark: o.remark,
            remarkEn: o.remarkEn != null && o.remarkEn !== '' ? o.remarkEn : o.remark_en,
            materialDensity: o.materialDensity,
            membraneWidth: o.membraneWidth,
            isThickness: o.isThickness === true ? 1 : (o.isThickness === false ? 0 : o.isThickness),
            materialThickness: o.materialThickness,
            sellingPrice: o.sellingPrice,
            costPrice: o.costPrice,
            weight: o.weight,
            unitOfMeasurement: (o.unitOfMeasurement != null && o.unitOfMeasurement !== '') ? o.unitOfMeasurement : (o.unit_of_measurement != null ? o.unit_of_measurement : null),
            laborCosts: o.laborCosts != null ? o.laborCosts : o.labor_costs,
            laborWeight: o.laborWeight != null ? o.laborWeight : o.labor_weight,
            isConflict: o.isConflict === true ? 1 : (o.isConflict === false ? 0 : o.isConflict),
            status: o.status,
            _rowKey: `${o.id || ''}-${Math.random().toString(16).slice(2)}`
          })).map(o => {
            // 密度材料场景：默认“是否正常厚度”为是
            if (Number(data.isDensity) === 1 && (o.isThickness === null || o.isThickness === undefined || o.isThickness === '')) {
              o.isThickness = 1
            }
            return o
          }) : []
        }
        if (merged.is_show != null && merged.is_show !== '' && (merged.isShow === null || merged.isShow === undefined)) {
          merged.isShow = merged.is_show
        }
        if (Object.prototype.hasOwnProperty.call(merged, 'is_show')) {
          delete merged.is_show
        }
        if (merged.isShow === null || merged.isShow === undefined || merged.isShow === '') {
          merged.isShow = 1
        } else {
          const s = Number(merged.isShow)
          merged.isShow = Number.isNaN(s) ? 1 : s
        }
        this.form = merged
        this.$nextTick(() => {
          this.syncSpecOptionListIsCalculation(this.form.isCalculation)
        })
        this.open = true
        this.formTitle = this.$t('views.spec.title.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const mainCalcRaw = this.form.isCalculation === null || this.form.isCalculation === undefined ? 0 : Number(this.form.isCalculation)
          const mainCalc = Number.isNaN(mainCalcRaw) ? 0 : mainCalcRaw
          const optionList = (this.form.specOptionList || []).map(o => ({
            id: o.id,
            name: o.name,
            nameEn: o.nameEn,
            sort: o.sort,
            isCalculation: mainCalc,
            isPrompt: o.isPrompt,
            url: o.url,
            content: o.content,
            contentEn: o.contentEn,
            remark: o.remark,
            remarkEn: o.remarkEn,
            materialDensity: o.materialDensity,
            membraneWidth: o.membraneWidth,
            isThickness: o.isThickness,
            materialThickness: o.materialThickness,
            sellingPrice: o.sellingPrice,
            costPrice: o.costPrice,
            laborCosts: o.laborCosts,
            laborWeight: o.laborWeight,
            weight: o.weight,
            unitOfMeasurement: o.unitOfMeasurement,
            isConflict: o.isConflict,
            status: o.status
          })).filter(o => o.name && String(o.name).trim().length > 0)
          const submitData = {
            ...this.form,
            defaultOption: this.normalizeDefaultOptionForSubmit(this.form.defaultOption),
            specOptionList: optionList
          }
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSpec(submitData).then(response => {

              if(response.success) {
                this.$message.success(this.$t('views.spec.msg.updateOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.spec.msg.updateFail');
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSpec(submitData).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.spec.msg.addOk'),3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.spec.msg.addFail');
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
    ,
    addOptionRow () {
      if (!this.form.specOptionList) {
        this.$set(this.form, 'specOptionList', [])
      }
      // 用 string 避免超过 JS 安全整数导致回显只显示 id
      const genId = `${Date.now()}${Math.floor(Math.random() * 1000)}`
      this.form.specOptionList.unshift({
        id: genId,
        name: '',
        nameEn: '',
        sort: 0,
        isPrompt: 0,
        url: null,
        content: null,
        contentEn: null,
        remark: null,
        remarkEn: null,
        materialDensity: null,
        membraneWidth: null,
        isThickness: 1,
        materialThickness: null,
        sellingPrice: null,
        costPrice: null,
        laborCosts: null,
        laborWeight: null,
        weight: null,
        unitOfMeasurement: null,
        isConflict: 0,
        status: 1,
        isCalculation: (() => {
          const v = Number(this.form.isCalculation)
          return Number.isNaN(v) ? 0 : v
        })(),
        _rowKey: `new-${Date.now()}-${Math.random().toString(16).slice(2)}`
      })
    },
    removeOptionRow (idx) {
      if (!this.form.specOptionList) return
      this.form.specOptionList.splice(idx, 1)
    }
  }
}
</script>
